import { $Props } from '@Ravnur-Inc/core/typings/tsx';
import upperFirst from '@Ravnur-Inc/nanoutils/string/upperFirst';
import { Vue, prop } from '@Ravnur-Inc/vue-class-component';

import './stats.scss';

const CN = 'stats';

type Stats$Type = 'ratings' | 'views' | 'likes' | 'comments' | 'count' | 'group';
type Size = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

class Props {
  count: string | number;
  iconSize = prop<Size>({ default: 'sm' });
  statType: Stats$Type;
}

export type Stats$Props = $Props<Props> & Partial<HTMLDivElement>;

const ICONS: { [key in Stats$Type]: string } = {
  ratings: 'star',
  views: 'eye',
  likes: 'thumb-up',
  comments: 'chat',
  count: 'collections-bookmark',
  group: 'group',
};

export default class Stats extends Vue.with(Props) {
  declare $props: Stats$Props;

  render() {
    return (
      <span class={CN} {...this.$attrs} data-testid="stats">
        <icon
          class={[`${CN}__icon`, `${CN}__icon--${this.statType}`]}
          size={this.iconSize}
          type={ICONS[this.statType]}
        />
        <span aria-label={upperFirst(this.statType)} class={`${CN}__count`}>
          {_label(this.statType, this.count)}
        </span>
      </span>
    );
  }
}

function _label(type: Stats$Type, count: string | number): string {
  if (type === 'ratings') {
    return `${count}/5`;
  }
  return `${count}`;
}
